<template lang="pug">
.v-files-page.files-page(v-if="data")
	h1.files-page__title(v-if="data.title") {{ data.title }}
	.files-page__sections(v-if="data.items")
		.files-page__section(v-for="(section, index) in data.items" :key="index" )
			.files-page__section-title(v-if="section.title" ) {{ section.title }}
			.files-page__section-rows(v-if="section.items" )
				.files-page__section-row(v-for="(row, index) in section.items" :key="index")
					.files-page__section-row-wrap
						.files-page__section-row-left
							img.files-page__section-image(v-if="row.image" :src="row.image" alt="")
							.files-page__section-name(v-if="row.name") {{ row.name }}
						.files-page__section-row-right
							.files-page__section-position(v-if="row.info") {{ row.info }}
							.files-page__section-contacts(v-if="row.link" )
								a.files-page__section-contact.btn.btn--transparent(
										v-if="row.link.href"
										:href="row.link.href|| '#'"
										download)
									v-svg-icon.icon-download(:icon="row.link?.icon")
									.link-inner(v-html="row.link?.text " )
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>